import React from "react"
import { Container } from "@mui/material"
import { ReportTypeEnum } from "pages/reports/interfaces/reports.interfaces"
import AddTemplateForm from "pages/reports/components/AddTemplateForm/AddTemplateForm"
import { ReportTemplateContextProvider } from "pages/reports/components/ReportTemplateContextProvider"

const AddUserTemplate = () => {
  return (
    <ReportTemplateContextProvider>
      <Container>
        <AddTemplateForm reportType={ReportTypeEnum.User} />
      </Container>
    </ReportTemplateContextProvider>
  )
}

export default AddUserTemplate